import React, { Component } from 'react';
import TopicItem from './TopicItem.js'

class Topic extends Component {
    render() {
        return (
            <div>
                <h3>{this.props.title}</h3>
                <ul class="hpy-sidebar">
                    {this.props.items.map((item) => (
                        <li>
                            <TopicItem title={item.title} link={item.link} />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default Topic;



// WEBPACK FOOTER //
// ./src/reference/ui/Topic.js